import { createSelector } from 'reselect';

// Config
import { getConfirmedDeliveryAddressSelector, getSelectedDeliveryChoiceIdSelector } from '../../../redux/reducers/delivery/deliverySelector';
import { getSelectedBillingAddressAddressSelector } from '../../../redux/reducers/user/userSelector';

const savedPaymentDetailsFormState = createSelector(
  [getConfirmedDeliveryAddressSelector, getSelectedBillingAddressAddressSelector, getSelectedDeliveryChoiceIdSelector],
  (confirmedDeliveryAddress, selectedBillingAddress, selectedDeliveryChoiceId) => ({
    confirmedDeliveryAddress: confirmedDeliveryAddress?.address,
    selectedBillingAddress,
    selectedDeliveryChoiceId,
  }),
);

export default savedPaymentDetailsFormState;
